import { format } from 'date-fns';
import fr from 'date-fns/locale/fr';

export default (date, formattedString, language = fr) =>
  format(date, formattedString, { locale: language });
